import { render, staticRenderFns } from "./UnPaidVisaDetail.vue?vue&type=template&id=33d8f9a0&"
import script from "./UnPaidVisaDetail.vue?vue&type=script&lang=js&"
export * from "./UnPaidVisaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports